$(function () {
  var legendCallback = function(chart) {
    var text = [];
    text.push('<ul class="chart__legend-list ' + chart.id + '-legend">');
    var legendItems = chart.legend.legendItems;
    for(var i=0; i < legendItems.length; i++) {
      var legendItem = legendItems[i];
      var label = legendItem.text;
      var dataset = chart.data.datasets[i];

      text.push('<li>');
      text.push('<div class="chart__icon-wrapper--wide"><div class="chart__legend-icon" style="background-color:' 
        + dataset.backgroundColor + ';"></div></div>');
      if (label) {
        text.push('<div class="chart__legend-text--narrow">' + label + '</div>');
      }
      text.push('</li>');
    }
    text.push('</ul>');
    return text.join("");
  };

  $('[data-behavior=stacked-line-chart]').existsEach(function ($stackedLineChart) {

    var dataAttr = $stackedLineChart.data('stacked-line-chart');

    var datasets = dataAttr.datasets;
    var labels = dataAttr.labels;

    var legendContainer = $stackedLineChart.find(dataAttr.legend);

    var canvas = $stackedLineChart.find('canvas');

    var stackedLineChart = new Chart(canvas, {
      type: 'line',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        tooltips: {
          enabled: true
        },
        legend: {
          display: false,        
        },
        legendCallback: legendCallback,
        scales: {
          xAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(255,255,255, 0.3)'
            },
            ticks: {
              fontColor: '#FFF'
            }
          }],
          yAxes: [{
            display: true,
            gridLines: {
              display: false
            },
            position: 'right',
            ticks: {
              suggestedMin: 0,
              fontColor: '#FFF'
            }
          }]
        }
      }
    });
    $(legendContainer).html(stackedLineChart.generateLegend());
  });
});
